import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'informed';

const InputRadio = ({
  label, value, className, disabled, ...props
}) => (
  <label className={`input-radio-type ${className} ${disabled && 'input-disabled'}`}>
    <span className="label-input">{label}</span>
    <Radio value={value} disabled={disabled} {...props} />
    <span className="radiomark" />
  </label>
);

InputRadio.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.oneOfType(
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ).isRequired,
};

InputRadio.defaultProps = {
  disabled: false,
  label: '',
  className: '',
};

export default InputRadio;
